import React from 'react';
import { connect } from 'react-redux';
import Modal from 'components/ui/modal';
import View from 'components/ui/view';
import { hideAvailability } from './actions';
import { trackNow } from 'shared/models/analytic';
import Address from './address';
import { setAddress } from '../address/actions';

let AvailabilityModal = class AvailabilityModal extends React.Component {
  setAddress(address) {
    return this.props.setAddress(address).then(() => {
      this.props.hideAvailability();
    });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        overlayClassName="modal-overlay"
        className="modal-content"
        handleClose={() => this.props.hideAvailability()}
        handleAfterOpen={() => trackNow('Availability Modal Viewed')}
      >
        <View padding="sm">
          <h2 className="address-modal__heading">Get This Delivered</h2>
          <div className="address-modal__divider" />
          <Address
            setAddress={address => this.setAddress(address)}
            trackingParams={{
              page: 'Product Page',
              source: 'Availability Modal'
            }}
          />
        </View>
      </Modal>
    );
  }
};

AvailabilityModal = connect(
  state => ({
    open: state.availability.open,
    address: state.address
  }),
  { hideAvailability, setAddress }
)(AvailabilityModal);

export default AvailabilityModal;



// WEBPACK FOOTER //
// ./shared/components/availability/index.js